<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";

import { defineProps, ref, computed, watch } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  jenisdok: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  nama: "",
  deskripsi: "",
});
watch(
  () => props.jenisdok,
  (newJenis) => {
    if (newJenis) {
      form.id = newJenis.id;
      form.nama = newJenis.nama;
      form.deskripsi = newJenis.deskripsi;
    }
  },
  { immediate: true, deep: true }
);
// Close modal
const closeModal = () => {
  emit("update:isOpen", false); // Emit event untuk menutup modal
};

// Handle click outside modal
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  const routeName = form.id ? "jenisdokumen.update" : "jenisdokumen.store";
  form[form.id ? "put" : "post"](route(routeName, form.id || {}), {
    onSuccess: () => {
      Swal.fire({
        title: "Berhasil!",
        text: `Data berhasil ${form.id ? "diperbarui" : "disimpan"}.`,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        form.reset();
        window.location.reload();
      });
    },
    onError: () => {
      Swal.fire("Error!", "Data gagal disimpan!", "error");
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
    @click="handleClickOutside"
  >
    <div class="relative w-1/2 h-auto p-6 overflow-y-auto bg-white rounded-lg">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div>
          <input
            type="text"
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            v-model="form.id"
            hidden
          />

          <label class="sr-only" for="Judul">Nama</label>
          <textarea
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            placeholder="Nama Dokumen"
            rows="8"
            v-model="form.nama"
          ></textarea>
          <InputError :message="form.errors.nama" />
        </div>
        <div>
          <label class="sr-only" for="Deskripsi">Deskripsi</label>
          <textarea
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            placeholder="Deskripsi"
            rows="8"
            v-model="form.deskripsi"
          ></textarea>
          <InputError :message="form.errors.deskripsi" />
        </div>

        <div class="mt-4">
          <PrimaryBtn>
            <i class="fa-solid fa-floppy-disk"></i> SIMPAN
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
